<div class="kt-container  kt-grid__item kt-grid__item--fluid" *ngIf="enrollmentData">
  <ng-container *ngFor="let alert of alerts$ | async">
      <rek-alert-framed [icon]="'flaticon-exclamation-1'" [text]="alert.text" [additionalClasses]="'alert-danger'"></rek-alert-framed>
  </ng-container>

  <rek-header-card [enrollmentInfo]="enrollmentInfo"></rek-header-card>

  <div class="row" *ngIf="enrollmentData.isActive && !isAuthenticated">
    <div class="col-lg-6">
      <rek-icon-card [href]="AuthPaths.Login" [cardTitleTranslateKey]="'HOME.ROOT.LOGIN-CARD.TITLE'" [cardSubtitleTranslateKey]="'HOME.ROOT.LOGIN-CARD.SUBTITLE'">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
          height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <path
              d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
              fill="#000000" opacity="0.3"></path>
            <path
              d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
              fill="#000000"></path>
            <path
              d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
              fill="#000000"></path>
          </g>
        </svg>
      </rek-icon-card>
    </div>
    <div class="col-lg-6">
      <rek-icon-card [href]="AuthPaths.Register" [cardTitleTranslateKey]="'HOME.ROOT.REGISTER-CARD.TITLE'" [cardSubtitleTranslateKey]="'HOME.ROOT.REGISTER-CARD.SUBTITLE'">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
          height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24"></polygon>
            <path
              d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
              fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
            <path
              d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
              fill="#000000" fill-rule="nonzero"></path>
          </g>
        </svg>
      </rek-icon-card>
    </div>
  </div>
</div>

<ng-container *ngIf="infoBoxTabs$ | async as infoBoxTabs">
  <ng-container *ngIf="infoBoxTabs && infoBoxTabs.length > 0">
    <div class="kt-container" [class.rek-larger-margin]="!enrollmentData || !enrollmentData.isActive">
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <rek-spinner *ngIf="!isLoaded"></rek-spinner>
            <rek-info-box 
              [title]="(enrollmentData.isActive ? 'HOME.ROOT.CURRENT-ENROLLMENT-TITLE' : 'HOME.ROOT.INACTIVE-ENROLLMENT-TITLE') | translate" 
              [infoBoxTabs]="infoBoxTabs">
            </rek-info-box>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>